import { createFileRoute, redirect } from '@tanstack/react-router'
import { supabase } from '@/lib/supabase/client'
import { ResetPassword } from '@/features/auth/reset-password'

export const Route = createFileRoute('/(auth)/reset-password')({
  beforeLoad: async () => {
    // Check the Supabase session directly instead of React context.
    // After recovery OTP verification, the session exists immediately
    // but the React auth context hasn't updated yet.
    const {
      data: { session },
    } = await supabase.auth.getSession()
    if (!session) {
      throw redirect({ to: '/sign-in' })
    }
  },
  component: ResetPassword,
})
